import hubkami from "../../../assets/img/hubungi-kami/imgPeople-HubKami.png";
import icHotline from "../../../assets/img/hubungi-kami/phone.svg";
import icWA from "../../../assets/img/hubungi-kami/tabler-icon-brand-whatsapp.svg";
import icEmail from "../../../assets/img/hubungi-kami/mail.svg"

function Home() {

    return (
        <>
            <div className="hubungi-kami">
                <div className="card-hero">
                    <div className="text">
                        <div className="row-title">
                            <h4>Hubungi Kami</h4>
                            <p/>Silakan hubungi kami Senin - Jumat | 09.00 - 17.00 WIB
                        </div>
                        <div className="row-info">
                            <div className="hotline">
                                <img src={icHotline} alt="hotline"/>
                                <div className="inner-info">
                                    <p className="title-info">Hotline</p>
                                    <p>021 - 5010 3363</p>
                                </div>
                            </div>
                            <a className="whatsapp" href="https://wa.me/6281295927442">
                                <img src={icWA} alt="whatsapp"/>
                                <div className="inner-info">
                                    <p className="title-info">WhatsApp Chat Only</p>
                                    <p>(+62) 812 9592 7442</p>
                                </div>
                            </a>
                            <a className="email" href="mailto:customer.care@danai.id">
                                <img src={icEmail} alt="email"/>
                                <div className="inner-info">
                                    <p className="title-info">Email</p>
                                    <p>customer.care@danai.id</p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div className="image">
                        <img src={hubkami} alt="hubungi-kami"/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
